export default "__VITE_ASSET__BpFy8IXh__"